<script setup>
import HrItemLabel from '../primitives/HrItemLabel.vue';

/**
 * Section header label for a list group.
 *
 * @status recommended
 * @group lists-tables
 * @useWhen Labeling a group of list items; placed at the top of an HrListGroup
 * @useWhen Labeling a group of items inside a menu, above the HrMenuItem rows it covers
 * @related HrListGroup
 * @within hr-list
 * @within hr-list-group
 */
defineOptions({ name: 'HrListSectionHeader' });
</script>

<template>
  <hr-item-label
    header
    class="hr-list-section-header"
  >
    <!-- @slot Header text. -->
    <slot />
    <span v-if="$slots.trailing">
      <!-- @slot Trailing content, e.g. a count badge or action button. -->
      <slot name="trailing" />
    </span>
  </hr-item-label>
</template>

<style lang="scss" scoped>

.hr-list-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

</style>
